// NavigationContext import removed - not used in this file

export const routerConfig = {
  future: {
    v7_startTransition: true
  },
  basename: '/'
};